module.exports = __webpack_public_path__ + "673c57f5cfaf1fea688d852cca50e982.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/researcher.png
 ** module id = 1077
 ** module chunks = 0
 **/